import { createRoot } from 'react-dom/client';
import './i18n';
import './styles.css';
import { ThemeProvider } from './theme/ThemeContext';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
